export const SHOW_LOADER = 'LOADER:SHOW'

export const showLoader = (show) => ({
  type: SHOW_LOADER,
  show,
})